// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/ruleView/SaveRulesModal.scss
// module id = 2187
// module chunks = 0